import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { IProps } from './SelectFromCloudPopup.types';

export const openSelectFromCloudPopup = ({ onSuccess, onClose, isEmpty, emptyText, titleText, submitBttnText, oneFileOnly = false }) =>
    openPopupHelper<IProps>({
        popupName: popupNames.SELECT_FROM_CLOUD_DIALOG,
        data: { onSuccess, onClose, isEmpty, titleText, submitBttnText, emptyText, oneFileOnly },
    });
